(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["blog-stories-list"] && !Shopify.designMode) return;
  try {
    (()=>{
    const init=root=>{
      if(root.dataset.storiesReady)return;
      root.dataset.storiesReady='true';
      const button=root.querySelector('[data-stories-more]');
      if(!button)return;
      const grid=root.querySelector('[data-stories-grid]');
      const status=root.querySelector('[data-stories-load-status]');
      button.hidden=false;
      button.addEventListener('click',async()=>{
        if(button.disabled||!root.dataset.nextUrl)return;
        button.disabled=true;
        button.setAttribute('aria-busy','true');
        status.hidden=true;
        try{
          const url=new URL(root.dataset.nextUrl,window.location.href);
          if(url.origin!==window.location.origin)throw new Error('Invalid Stories URL');
          const response=await fetch(url.href,{credentials:'same-origin'});
          if(!response.ok)throw new Error('Stories request failed');
          const page=new DOMParser().parseFromString(await response.text(),'text/html');
          const nextRoot=page.querySelector('[data-stories-list]');
          const cards=[...nextRoot.querySelectorAll('[data-stories-grid] > .stories-list__card')];
          if(!cards.length)throw new Error('No Stories cards returned');
          const fragment=document.createDocumentFragment();
          cards.forEach(card=>fragment.appendChild(card));
          grid.appendChild(fragment);
          root.dataset.nextUrl=nextRoot.dataset.nextUrl||'';
          button.hidden=!root.dataset.nextUrl;
          cards[0].querySelector('a')?.focus();
        }catch(error){
          status.textContent=root.dataset.loadError;
          status.hidden=false;
          if(window.console&&console.warn)console.warn('Could not load Stories.',error);
        }finally{
          button.disabled=false;
          button.removeAttribute('aria-busy');
        }
      });
    };
    const boot=()=>document.querySelectorAll('[data-stories-list]').forEach(init);
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
    document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-stories-list]').forEach(init));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["home-language-pill"] && !Shopify.designMode) return;
  try {
    (() => {
    const pill = document.getElementById('HomeLanguagePillForm');
    if (!pill) return;
    pill.querySelector('[data-home-language-select]')?.addEventListener('change', () => pill.requestSubmit());
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["review-form-theme"] && !Shopify.designMode) return;
  try {
    (() => {
    const container = document.querySelector('.is-review-page [data-form-root]');
    if (!container || !('adoptedStyleSheets' in Document.prototype)) return;

    const sheet = new CSSStyleSheet();
    sheet.replaceSync(`
      [hidden] { display: none !important; }
      /* Shopify Forms clips its form sections, which cuts off the right edge of the focus ring. */
      section[class*="_inline_"],
      section[class*="_formContainer_"] { overflow: visible; }
      h2[class*="_textHeading_"] {
        margin: 0 0 .6rem;
        font-family: var(--font-display);
        line-height: 1.1;
        letter-spacing: -.035em;
      }
      [class*="_textBody_"] { line-height: 1.55; }
      input[class*="_formInputField_"], textarea {
        border-radius: .65rem;
      }
      /* Same as the storefront CTA (.btn.btn--primary in critical.css). Shopify Forms sizes its button
         through its own classes, so the box rules need !important to win. */
      button[class*="_formSubmitButton_"] {
        box-sizing: border-box;
        display: inline-flex !important;
        align-self: flex-start;
        align-items: center;
        justify-content: center;
        gap: .6rem;
        width: auto !important;
        height: auto !important;
        min-height: 3rem !important;
        margin-top: .5rem;
        padding: .75rem 1.5rem !important;
        border: 1px solid rgba(232, 186, 163, .5) !important;
        border-radius: .75rem !important;
        background: var(--gradient-key) !important;
        background-color: var(--rose) !important;
        background-size: 170% 170% !important;
        background-position: 0 50% !important;
        box-shadow: 0 1px 0 rgba(255, 255, 255, .32) inset, 0 10px 24px -14px rgba(184, 115, 97, .72) !important;
        color: var(--on-accent) !important;
        font-family: var(--font-body);
        font-size: .9375rem !important;
        font-weight: 650;
        line-height: 1.2;
        letter-spacing: .015em;
        cursor: pointer;
        transition: background-position .45s var(--ease), border-color .3s var(--ease), box-shadow .3s var(--ease), transform .3s var(--ease), opacity .3s;
      }
      button[class*="_formSubmitButton_"]:hover {
        border-color: rgba(232, 186, 163, .88) !important;
        background-position: 100% 50% !important;
        box-shadow: 0 1px 0 rgba(255, 255, 255, .38) inset, 0 15px 30px -14px rgba(184, 115, 97, .85) !important;
        transform: translateY(-1px);
      }
      button[class*="_formSubmitButton_"]:active { transform: translateY(0); }
      button[class*="_formSubmitButton_"]:disabled { opacity: .62; cursor: not-allowed; transform: none; }
      fieldset[name="custom#overall_rating"] > div {
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        gap: .2rem;
        margin-block: .6rem 1rem;
      }
      fieldset[name="custom#overall_rating"] label {
        position: relative;
        display: inline-flex;
        width: 2.9rem;
        height: 2.9rem;
        align-items: center;
        justify-content: center;
        margin: 0;
        cursor: pointer;
      }
      fieldset[name="custom#overall_rating"] label::before {
        content: '★';
        color: var(--quiet);
        font-family: Arial, sans-serif;
        font-size: 2.15rem;
        line-height: 1;
        transition: color .15s, transform .15s;
      }
      fieldset[name="custom#overall_rating"] label:has(input:checked)::before,
      fieldset[name="custom#overall_rating"] label:has(~ label input:checked)::before,
      fieldset[name="custom#overall_rating"] label:hover::before,
      fieldset[name="custom#overall_rating"] label:has(~ label:hover)::before { color: var(--rose); transform: scale(1.08); }
      fieldset[name="custom#overall_rating"] input {
        position: absolute;
        inset: 0;
        width: 100%;
        height: 100%;
        margin: 0;
        opacity: 0;
        cursor: pointer;
      }
      fieldset[name="custom#overall_rating"] label span {
        position: absolute;
        width: 1px;
        height: 1px;
        overflow: hidden;
        clip-path: inset(50%);
        white-space: nowrap;
      }
      fieldset[name="custom#overall_rating"] label:has(input:focus-visible) {
        outline: 2px solid var(--rose);
        outline-offset: 2px;
        border-radius: .35rem;
      }
      @media (max-width: 400px) {
        fieldset[name="custom#overall_rating"] > div { gap: .1rem; }
        fieldset[name="custom#overall_rating"] label { width: 2.5rem; height: 2.5rem; }
        fieldset[name="custom#overall_rating"] label::before { font-size: 1.85rem; }
      }
      div[class*="_formDisclaimer_"] {
        margin-top: 1.5rem;
        padding-top: 1rem;
        border-top: 1px solid var(--line);
        color: var(--quiet);
        font-size: .75rem;
        line-height: 1.55;
      }
    `);

    const styled = new WeakSet();
    const style = () => {
      container.querySelectorAll('shopify-forms-embed').forEach((embed) => {
        const root = embed.shadowRoot;
        if (!root || styled.has(root)) return;
        styled.add(root);
        root.adoptedStyleSheets = [...root.adoptedStyleSheets, sheet];
      });
    };

    // The review request email links here with ?email=…&order=…&name=…&lang=…. If lang differs from
    // the page language, switch through the storefront's localization form (Shopify redirects a
    // plain /de-ch/ link back to the browser language) and keep the other values for the next load.
    // Shopify Forms has no URL prefill, so fill those fields (the name as initials, the language from
    // the page), show the order number as a label, and drop the values from the address bar. Email
    // and display name are required, so they hide only once filled; order number and language are
    // always hidden. Fields are found by their IDs, which stay the same when the form is translated.
    const params = new URLSearchParams(location.search);
    const pageLanguage = (document.documentElement.lang || '').toLowerCase().split('-')[0];
    const wantedLanguage = (params.get('lang') || '').trim().toLowerCase().split(/[-_]/)[0];
    const languageForm = document.getElementById('ReviewLanguageForm');
    // Storefront language codes can carry a region (pt-PT), so match on the language part.
    const targetLanguage = ((languageForm && languageForm.dataset.languages) || '').split(/\s+/).find((code) => code && code.toLowerCase().split('-')[0] === wantedLanguage);
    if (targetLanguage && wantedLanguage !== pageLanguage && !params.has('lang_switched')) {
      params.set('lang_switched', '1');
      const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      const path = `/${location.pathname.slice(root.length).replace(/^\/+/, '')}`;
      let returnTo = languageForm.elements.return_to;
      if (!returnTo) {
        returnTo = Object.assign(document.createElement('input'), { type: 'hidden', name: 'return_to' });
        languageForm.append(returnTo);
      }
      returnTo.value = `${path}?${params}`;
      languageForm.elements.language_code.value = targetLanguage;
      languageForm.submit();
      return;
    }

    const initials = (name) => name.split(/[\s-]+/).map((word) => Array.from(word)[0] || '').join('').toLocaleUpperCase().slice(0, 4);
    const prefill = {
      email: (params.get('email') || '').trim(),
      order: (params.get('order') || '').trim().replace(/^#/, ''),
      name: initials((params.get('name') || '').trim()),
      language: pageLanguage,
    };
    const valid = {
      email: (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value),
      order: (value) => /^[\w-]{1,32}$/.test(value),
      name: (value) => /^\p{L}{1,4}$/u.test(value),
      language: (value) => /^[a-z]{2}$/.test(value),
    };
    Object.keys(prefill).forEach((key) => {
      if (!valid[key](prefill[key])) prefill[key] = '';
    });
    const linkParams = ['email', 'order', 'name', 'lang', 'lang_switched'];
    if (linkParams.some((key) => params.has(key))) {
      linkParams.forEach((key) => params.delete(key));
      const query = params.toString();
      history.replaceState(history.state, '', location.pathname + (query ? `?${query}` : '') + location.hash);
    }
    if (prefill.order) {
      container.dataset.reviewOrder = prefill.order;
      container.dataset.reviewOrderLabel = 'Order';
    }

    const fieldIds = { email: /^email$/, order: /order/, name: /display_name/, language: /language/ };
    const alwaysHidden = ['order', 'language'];
    const findField = (root, key) => {
      const inputs = [...root.querySelectorAll('input:not([type="hidden"]):not([type="radio"]):not([type="checkbox"])')];
      return inputs.find((input) => fieldIds[key].test(input.id)) || (key === 'email' ? inputs.find((input) => input.type === 'email') : undefined);
    };
    const labelFor = (input, root) => {
      const label = (input.id && root.querySelector(`label[for="${CSS.escape(input.id)}"]`)) || input.closest('label');
      return label ? label.textContent.trim() : '';
    };
    // The outermost wrapper that still holds only this one field, so its label hides with it.
    const fieldWrapper = (input) => {
      let el = input;
      while (el.parentElement && el.parentElement.querySelectorAll('input, textarea, select, fieldset').length === 1) el = el.parentElement;
      return el;
    };
    const setValue = (input, value) => {
      Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set.call(input, value);
      input.dispatchEvent(new Event('input', { bubbles: true, composed: true }));
      input.dispatchEvent(new Event('change', { bubbles: true, composed: true }));
    };

    const handled = new WeakSet();
    const fill = (root) => {
      Object.entries(prefill).forEach(([key, value]) => {
        if (!value && !alwaysHidden.includes(key)) return;
        const input = findField(root, key);
        if (!input || handled.has(input)) return;
        handled.add(input);
        if (key === 'order' && labelFor(input, root)) container.dataset.reviewOrderLabel = labelFor(input, root).replace(/\s*\*$/, '');
        if (value) setValue(input, value);
        fieldWrapper(input).hidden = true;
      });
    };

    const watched = new WeakSet();
    const watch = (root) => {
      if (watched.has(root)) return;
      watched.add(root);
      fill(root);
      new MutationObserver(() => fill(root)).observe(root, { childList: true, subtree: true });
    };

    const attach = () => {
      style();
      container.querySelectorAll('shopify-forms-embed').forEach((embed) => embed.shadowRoot && watch(embed.shadowRoot));
    };

    customElements.whenDefined('shopify-forms-embed').then(attach);
    new MutationObserver(attach).observe(container, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
